import React from 'react';
import {Create} from 'react-admin';
import {SystemForm} from 'ReactAdminPages/Systems/SystemForm';

export const SystemCreate = (props: unknown): React.ReactElement => <Create {...props} >
    <SystemForm/>
</Create>;

